import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/MtoUnidadView',
    name: 'MtoUnidadView',
    component: () =>
      import('../views/configuracion/unidad/UnidadView.vue'),
    meta: {
      title: 'Buscador Unidad',
      roles: getRolesPantalla('MtoUnidadView'),
      requiresAuthentication: true,
      requiresAuthorization: false,
      bread: {
        path: [
          'Configuración',
        ],
      },
    },
  },
];
